export default {
    book: 'Užsakyti {product}',
    age_limit: 'Tik nuo {age} metų',
    change_plan: 'Keisti planą',
    upgrade_product: 'Patobulinti produktą',
    upgrade: 'Patobulinti',
    cancel_upgrade: 'Atšaukti patobulinimą',
    choose_product: 'Pasirinkti {product}',
    days: '{count} diena | {count} dienos',
    login_register: 'Prisijungti/Registruotis',
    current: 'Dabartinis',
    keyless_benefits: {
        label: 'Tiesiai prie automobilio {0}',
        highlight: 'nuomos paslauga™',
        list: {
            cant_lose_the_key: 'Pilnas draudimas',
            zero_excess: 'Nulinė franšizė',
            phone_as_a_key: 'Telefonas kaip raktas',
            straight_to_car: 'Be laukimo',
            no_queues: 'Be eilių',
            online_id_check: 'Tapatybės patikra internetu',
            self_checkout: 'Savarankiškas išsiregistravimas',
        },
    },
};
